export const red = "#ff4d4d80"; //transparent red 50%
//export const redNumber = "#dc3545";
export const redNumber = "#e00";
export const redBackground = "#ffeded"; //used in fit AgGrid
export const redBackgroundTransparent = "#ffededE6"; //used in fit AgGrid
export const redBackgroundNew = "#FF6565"; //used in order entry

export const green = "#a6f1a680"; //transparent green 50% 
//export const greenNumber = "#2ECC40";
//export const greenNumber = "#00f000";
export const greenNumber = "#0A8231";
export const greenBackground = "#dcffec"; //used in fit AgGrid
export const greenBackgroundTransparent = "#dcffecE6";
export const greenBackgroundNew = "#0C9801"; //used in order entry

export const blueNumber = "#0073e6";
export const blueInformation = "#3B86FF";

export const greyBackground = "rgba(87,87,77,.12)";
export const darkGreen = "#4bdc53";
export const orange = "#604413";


export const BackgroundSellBtn = 'rgb(238, 0, 0)'; 
export const BackgroundBuyBtn = '#0C9801';

// order statusBackground
export const BackgroundRed = '#660000';  
export const BackgroundGreen = '#006600';  
export const BackgroundBlue = '#165B81'; 
export const BackgroundOrange = '#f45d52'; 
// export const BackgroundGray = '#242625'; 
export const BackgroundGray = '#7f8284'; 

// Background Red/Green in darkTheme & lightTheme:
export const BackgroundGreenLightTheme= '#dcffec'; //used in order entry
export const BackgroundGreenDarkTheme = '#004800';  //used in order entry
export const BackgroundRedLightTheme = '#ffeded';  //used in order entry
export const BackgroundRedDarkTheme = '#600';  //used in order entry
export const BackgroundBlueLightTheme = '#D5EEFF';  //used in order list



/* DarkTheme */
export const greenNumberDarkTheme = "#09F930";


/* #e00 !important red to change
#0c9801 green  */